
<template>
    <div>
        <Breadcrumbs main="" :title='$t("lbl_EMPBE_DowloadCenter")' />

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <Donwloads v-for="(download,index) in downloads" :data="download" v-bind:key="index"></Donwloads>
            </div>
        </div>
        
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import Donwloads from "./Components/donwloads.vue";
import { downloadCenterService } from "@/_services/downloadcenter.service";
export default {
    data() {
        return {
            downloads: []
        };
    },
    created() {
        this.getDownloadCenter();
    },
    methods: {
        async getDownloadCenter() {
            var that = this;
            var _langId = localStorage.currentLangId;
            downloadCenterService.getDownloadCenter({ langId: _langId }).then(response => {
                console.log(response);
                if (response.statusCode == 200) {
                    var data = response.data;
                    that.downloads = data;
                }
            });
        }
    },
    components: { Donwloads }
}
</script>
<style>

</style>
  